import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import Count from "../components/Count";
import { TitleText } from "../../../ui/Text";
import Header from "../components/Header";
import SearchInput from "../../../ui/SearchInput";
import Accordion from "../../../ui/Accordion";
import Modal from "../../../ui/Modal";
import { useParams, useLocation } from "react-router-dom";
import { GetHook, postEndpoint, putEndpoint } from "../../../api/api";
import { SCORECARD_URL, KPI_URL } from "../../../api/urls";
import { get } from "../../../utils/get";
import { parseDropdown } from "../../../utils/parseDropdown";
import Axios from "../../../utils/axios";
import AddKpi from "./AddKpi";
import Comment from "../../../ui/Comment";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { Button } from "../../../ui/Button";
import Preview from "./ScorecardPreview/Preview";
import AddKpi360 from "./AddKPI360";

interface IProps {
  scorecard_id?: any;
  scorecard?: any;
}

const KPIComponent360 = ({ scorecard_id, scorecard }: IProps) => {
  const [isModalOpen, setisModalOpen] = useState(false);
  const [kpis, setKpis] = useState<any>([]);
  const [kpi, setKpi] = useState<any>([]);
  const [objective, setObjective] = useState<any>([]);
  const [isEdit, setIsEdit] = useState(false);
  const [kpiId, setKpiId] = useState();
  const [editData, setEditData] = useState<any>([]);
  const [modalContent, setModalContent] = useState("kpi");
  const { id } = useParams();

  const { data, error, pending, reload } = GetHook(
    get(objective[0], "objective_id")
      ? `${SCORECARD_URL}/${scorecard_id}/kpi/v1?objective_id=${
          objective && get(objective[0], "objective_id")
        }`
      : "null"
  );

  const location = useLocation();
  const isAddMode = !kpiId;

  const fetchObjective = () => {
    Axios.get(`${SCORECARD_URL}/${scorecard_id}/objective/v1`).then((res) => {
      const { returned_resultset } = get(res, "data");
      setObjective(
        returned_resultset.filter((objective) => objective?.objective_id === id)
      );
    });
  };

  const fetchKpi = () => {
    Axios.get(
      `${KPI_URL}?objective_id=${
        objective && get(objective[0], "objective_id")
      }`
    ).then((res) => {
      const { returned_resultset } = get(res, "data");
      setKpi(returned_resultset);
    });
  };

  useEffect(() => {
    fetchObjective();
    setKpis(data);
    return () => {};
  }, [data, id]);

  useEffect(() => {
    if (isModalOpen) {
      fetchKpi();
    }
    return () => {};
  }, [isModalOpen]);

  const toggleModal = (content, kpi) => {
    setModalContent(content);
    setKpiId(kpi.id);
    setisModalOpen(true);
  };

  const setEdit = (kpi) => {
    setIsEdit(true);
    setKpiId(kpi.id);
    setEditData(kpi);
    setisModalOpen(true);
  };

  const closeModal = () => {
    setModalContent("kpi");
    setisModalOpen(false);
    setIsEdit(false);
    setKpiId(undefined);
    setEditData({});
    reload(get(location, "key"));
  };

  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.value) {
        if (id) {
          Axios.delete(`${SCORECARD_URL}/${scorecard_id}/kpi/${id}`)
            .then((res) => {
              setKpis(kpis.filter((kpi: any) => kpi.id != id));
              toast.success("KPI has been deleted");
              reload(get(location, "key"));
            })
            .catch((error) => toast.error(error.response.data.message));
        }
      }
    });
  };

  return (
    <KPIsContainer>
      <KPIsHeaderSection>
        <div>
          <TitleText>
            {objective && get(objective[0], "objective_name")}
          </TitleText>
        </div>

        <DescriptionSection>
          {objective && get(objective[0], "weight", "-")}
        </DescriptionSection>
      </KPIsHeaderSection>
      <Header
        title="KPIs"
        count={kpis && kpis.length}
        setisModalOpen={setisModalOpen}
      />
      {isModalOpen && (
        <Modal
          title={!isEdit ? "Add new KPI" : "Edit KPI"}
          closeModal={closeModal}
          noHeader={modalContent === "kpi" ? false : true}
          width={modalContent === "preview" ? "90%" : "40em"}
          noFooter
        >
          {modalContent === "kpi" ? (
            <AddKpi360
              isAddMode={isAddMode}
              isEdit={isEdit}
              scorecard_id={scorecard_id}
              kpi={kpi}
              closeModal={closeModal}
              editData={editData}
            />
          ) : modalContent === "comment" ? (
            <Comment
              closeModal={closeModal}
              url={`scorecardkpi/${kpiId}`}
              scorecard_id={scorecard_id}
            />
          ) : (
            <Preview scorecardId={scorecard_id} closeModal={closeModal} />
          )}
        </Modal>
      )}
      <SearchInput />
      <ListContainer>
        {kpis &&
          kpis.map((kpi) => (
            <Accordion
              kpi={kpi}
              key={kpi.id}
              showEdit={setEdit}
              handleDelete={() => handleDelete(kpi.kpi_id)}
              toggleComment={toggleModal}
              isActive={get(scorecard, "[0]status") === "active" ? true : false}
              hasComments
            />
          ))}
      </ListContainer>
    </KPIsContainer>
  );
};

export default KPIComponent360;

const KPIsContainer = styled.div`
  display: grid;
  grid-template-rows: 18em 5em 4.25em auto;
  border-right: 1px solid rgba(55, 81, 255, 0.1);
`;

const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const KPIsHeaderSection = styled.div`
  display: grid;
  grid-template-rows: 3em 7em;
  padding: 1em;
  padding-top: 2.3em;
  border-bottom: 1px solid rgba(55, 81, 255, 0.1);
  div {
    display: flex;
    justify-content: space-between;
  }
`;

const DescriptionSection = styled.div`
  font-size: 0.75em;
  font-weight: 500;
  font-style: regular;
  color: #cdd3de;
`;

const PreviewButton = styled(Button)`
  border: 1px solid #D51067;
  padding: 0.3em 2em;
`;
